const mui = {
  MuiGrid: {
    styleOverrides: {
      container: { justifyContent: `center` },
    },
  },
};
export default mui;
